import createSvgIcon from '../createSvgIcons'

/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  [
    <path
      key={0}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 3C7.5 1.89543 8.39543 1 9.5 1H15.5C16.6046 1 17.5 1.89543 17.5 3V5C17.5 6.10457 16.6046 7 15.5 7H9.5C8.39543 7 7.5 6.10457 7.5 5V3ZM15.5 3H9.5V5H15.5V3Z"
      fill="currentColor"
    />,
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 5C6.23478 5 5.98043 5.10536 5.79289 5.29289C5.60536 5.48043 5.5 5.73478 5.5 6V20C5.5 20.2652 5.60536 20.5196 5.79289 20.7071C5.98043 20.8946 6.23478 21 6.5 21H18.5C18.7652 21 19.0196 20.8946 19.2071 20.7071C19.3946 20.5196 19.5 20.2652 19.5 20V6C19.5 5.73478 19.3946 5.48043 19.2071 5.29289C19.0196 5.10536 18.7652 5 18.5 5H16.5C15.9477 5 15.5 4.55228 15.5 4C15.5 3.44772 15.9477 3 16.5 3H18.5C19.2956 3 20.0587 3.31607 20.6213 3.87868C21.1839 4.44129 21.5 5.20435 21.5 6V20C21.5 20.7957 21.1839 21.5587 20.6213 22.1213C20.0587 22.6839 19.2957 23 18.5 23H6.5C5.70435 23 4.94129 22.6839 4.37868 22.1213C3.81607 21.5587 3.5 20.7957 3.5 20V6C3.5 5.20435 3.81607 4.44129 4.37868 3.87868C4.94129 3.31607 5.70435 3 6.5 3H8.5C9.05228 3 9.5 3.44772 9.5 4C9.5 4.55228 9.05228 5 8.5 5H6.5ZM8.79289 11.7071C8.40237 11.3166 8.40237 10.6834 8.79289 10.2929C9.18342 9.90237 9.81658 9.90237 10.2071 10.2929L12.5 12.5858L14.7929 10.2929C15.1834 9.90237 15.8166 9.90237 16.2071 10.2929C16.5976 10.6834 16.5976 11.3166 16.2071 11.7071L13.9142 14L16.2071 16.2929C16.5976 16.6834 16.5976 17.3166 16.2071 17.7071C15.8166 18.0976 15.1834 18.0976 14.7929 17.7071L12.5 15.4142L10.2071 17.7071C9.81658 18.0976 9.18342 18.0976 8.79289 17.7071C8.40237 17.3166 8.40237 16.6834 8.79289 16.2929L11.0858 14L8.79289 11.7071Z"
      fill="currentColor"
    />,
  ],
  'ClipboardClose'
)
